import { useState, useEffect } from 'react';
import useAuth from './useAuth';
import { STOCKITEMS_BASE_URL } from '../config';
import API from '../API';

const initialState = {
  page: 0,
  timeAttendance: '',
  total_pages: 0,
  total_results: 0,
  imageUrl: '',
};

export const useTimeAttendanceFetch = (id) => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const accessToken = auth.auth.accessToken;

  useEffect(() => {
    if (!id) return; // Prevents unnecessary API calls

    const fetchTimeAttendance = async () => {
      try {
        setLoading(true);
        setError(false);

        // Fetch stock item data
        const timeAttendance = await API.fetchTimeAttendance(id, accessToken);
        const timeAttendanceData = timeAttendance?.timeAttendance || initialState;

       console.log(timeAttendance)

        setState((prevState) => ({
          ...prevState,
          ...timeAttendance,
       
        }));
      } catch (error) {
        console.error('Error fetching stock item:', error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchTimeAttendance();

  }, [id, trigger]);

  return { state, loading, error, setLoading, setTrigger };
};
